const initialState = {
  alertsQueue: [],
  alerts: [],
  alertTimer: 3,
};

export default initialState;
